import { callApi } from "@/api/api-core";

export const fetchSystemInfo = function() {
    return callApi("POST", "v23/system/info", undefined, false);
};

export const fetchServerTime = function() {
    return callApi("GET", "v1/time/current", undefined, false);
};
